import { render, staticRenderFns } from "./SearchPhrases.vue?vue&type=template&id=7f70b202"
import script from "./SearchPhrases.vue?vue&type=script&lang=js"
export * from "./SearchPhrases.vue?vue&type=script&lang=js"
import style0 from "./SearchPhrases.vue?vue&type=style&index=0&id=7f70b202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports